// extracted by mini-css-extract-plugin
module.exports = {"container":"ClosedSafeDeal_container_CAJ5E","deal":"ClosedSafeDeal_deal_yndhe","title":"ClosedSafeDeal_title_1-yWb"};